<template>
  <div style="background: #f2f2f6; height: 100%">
    <el-row>
        <el-col :span="20">
             <el-radio-group style="margin:10px" fill='#cfa52c' v-model="actiongroup" size="small" @change="groupChange">
      <el-radio-button v-for="item in groupName" :label="item" :key="item"></el-radio-button>
      <el-radio-button  :label="$t('device.noGounp')" ></el-radio-button>
    </el-radio-group>
          </el-col>
          <el-col :span="4">
          <el-select
                size="mini"
                v-model="$store.state.deviceinnerid"
                style="margin:10px"
                v-if="$store.state.devicelist.length>1||$store.state.slavenum"
                 @change="changeDevice"
              >
                <el-option
                  v-for="item in $store.state.devicelist"
                  :key="item.innerid"
                  :label="item.name"
                  :value="item.innerid"
                  v-if="item.subdevs<=($store.state.slavenum+1)||item.type!='heatpump'"
                >
                </el-option>
              </el-select>
              </el-col>
    </el-row>
       <el-descriptions :labelStyle="{width:'200px'}" :contentStyle="{width:'250px'}" :column="3" size="mini" border>
      <el-descriptions-item v-for="d in fixedDp" :key="d.dpid" v-if="!(user.logintype==2&&d.hide)&&getValiddp(d)">
      <template slot="label">
        {{  $i18n.locale=='en'?(d.desc_en||d.desc): d.desc}}
      </template>
        <span v-if="d.type==2">{{$store.state.device[d.name]}}{{d.unit}}</span>
        <span v-else>{{getDpText($store.state.device,d.name)}}</span>
    </el-descriptions-item>
  </el-descriptions>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'Devices',
  data () {
    return {
      user: {},
      actiongroup: '',
      fixedDp: []
    }
  },
  computed: {
    groupName () {
      let groupname = this.dplist.filter(d => { return d.groupname }).map(d => { return d.groupname })
      groupname = Array.from(new Set(groupname))
      return groupname
    },
    dplist: {
      get () {
        if (this.$store.state.device && this.$store.state.device.innerid) {
          return this.$store.state.device.dplist.filter(d => { return d.xrw === 2 && (!d.subhide || (d.subhide === 1 && this.$store.state.device.subdevs === 1) || (this.$store.state.device.subdevs > 1 && d.subhide > 1)) })
        } else {
          return []
        }
      }
    }
  },
  watch: {
    '$store.state.deviceinnerid': function () {
      this.actiongroup = this.groupName[0] || this.$t('device.noGounp')
      if (this.actiongroup == this.$t('device.noGounp')) {
        this.fixedDp = this.dplist.filter(d => { return !d.groupname })
      } else {
        this.fixedDp = this.dplist.filter(d => { return d.groupname == this.actiongroup })
      }
    }
  },
  mounted: function () {
    var self = this
    let customer = window.localStorage.getItem('customer')
    if (customer) {
      this.user = JSON.parse(customer)
      self.actiongroup = self.groupName[0] || self.$t('device.noGounp')
      if (self.actiongroup == self.$t('device.noGounp')) {
        self.fixedDp = self.dplist.filter(d => { return !d.groupname })
      } else {
        self.fixedDp = self.dplist.filter(d => { return d.groupname == self.actiongroup })
      }

      this.$forceUpdate()
    } else {
      this.$message({
        message: this.$t('base.noSession'),
        type: 'warning'
      })
      self.$router.push({ name: 'Login' })
    }
  },
  methods: {
    changeDevice () {
      // this.$store.state.device = this.heatpump.filter(d => { return d.innerid === this.$store.state.deviceinnerid })[0]
      this.$store.state.device = this.$store.state.devicelist.filter(d => { return d.innerid === this.$store.state.deviceinnerid })[0]
      this.actiongroup = this.groupName[0] || this.$t('device.noGounp')
      if (this.actiongroup == this.$t('device.noGounp')) {
        this.fixedDp = this.dplist.filter(d => { return !d.groupname })
      } else {
        this.fixedDp = this.dplist.filter(d => { return d.groupname == this.actiongroup })
      }
      this.$forceUpdate()
    },
    getDpText (device, tag) {
      let dp = device.dplist.filter(d => { return d.name === tag })
      if (dp && dp.length > 0) {
        if (dp[0].type === 1) {
          let o = []
          if (this.$i18n.locale == 'en') {
            o = dp[0].options_en.filter(o => { return o.value === device[tag] })
          } else {
            o = dp[0].options.filter(o => { return o.value === device[tag] })
          }
          if (o && o.length > 0) {
            return o[0].text
          } else {
            return device[tag]
          }
        } else {
          return device[tag]
        }
      } else {
        return ''
      }
    },
    getValiddp (dp) {
      if (dp.validdp) {
        let cdp = this.dplist.filter(d => { return d.dpid == dp.validdp })
        if (cdp && cdp.length > 0) {
          if (JSON.parse(dp.validdt).indexOf(this.$store.state.device[cdp[0].name]) >= 0) {
            return true
          } else {
            return false
          }
        } else {
          return true
        }
      } else {
        return true
      }
    },
    groupChange () {
      if (this.actiongroup == this.$t('device.noGounp')) {
        this.fixedDp = this.dplist.filter(d => { return !d.groupname })
      } else {
        this.fixedDp = this.dplist.filter(d => { return d.groupname == this.actiongroup })
      }
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

/* .el-table >>> .el-table__column-filter-trigger {
  margin-right: 30px;
}
.el-table >>> .el-tag.el-tag--success {
  margin-right: 30px;
} */

</style>



// WEBPACK FOOTER //
// src/components/Devices/Heatpump.vue